import React from 'react';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import clsx from 'clsx';

const CarouselWithInformativeCardsSlide = ({ data, color }) => (
  <div className={clsx('carousel-informative-slide', `ci-slide-${color}`)}>
    <div className="ci-slide-image-wrapper">
      <Image field={data.fields.image} />
    </div>
    <div className="ci-slide-heading">
      <Text field={data.fields.heading} />
    </div>
    <RichText className="ci-slide-text" field={data.fields.text} />
  </div>
);

export default CarouselWithInformativeCardsSlide;
